import React from "react"
import { Popover, Table } from "antd"
import ProgressBar from "../../../../components/ProgressBar"
import { Link } from "react-router-dom"
import "./index.less"
import questionIcon from "images/question.svg"
import { validate } from "../../../../utils/functions"
import { get } from "lodash"
import { loadTexts, sanitize } from "../../../../utils/i18n"

const ResultTeamTableComponent = (props) => {
  const intlResultTeamTableComponent = loadTexts("reports_team_analysis_view")
    .resultTeamTableComponent
  const { dataSource, isLoading, match, measureInfo } = props

  const columnProgressComponent = (value, record) => {
    return (
      <div>
        {record.anonymity_check.valid ? (
          <ProgressBar
            style={{ width: "80%" }}
            custom={{
              color: record.response_rate.rate_color,
              value: record.response_rate.rate,
              value_visible: record.response_rate.rate_visible,
            }}
          />
        ) : (
          <Popover
            content={
              <div style={{ maxWidth: 220, textAlign: "center" }}>
                {intlResultTeamTableComponent.tooltipAnonymity.totalResponse}
                {record.anonymity_check.current_used}{intlResultTeamTableComponent.tooltipAnonymity.showResults}
              </div>
            }>
            <div style={{ width: "fit-content" }}>-</div>
          </Popover>
        )}
      </div>
    )
  }

  const columnPreviousMeasurementComponent = (value, record) => {
    if (record.prev_value === "") {
      return "-"
    }

    if (!record.anonymity_check.valid) {
      return "-"
    }

    return (
      <div className="table-previous-measurement">
        <div className="table-previous-measurement-percent">
          {validate.empty(record.prev_value) ? "" : `${record.prev_value}`}
        </div>
        <div className="table-previous-measurement-indicator">
          {get(record, "variation", 0) !== 0 && (
            <>
              <span
                className={`${
                  get(record, "variation", 0) > 0
                    ? "table-previous-measurement-indicator-green"
                    : "table-previous-measurement-indicator-red"
                }`}>
                {get(record, "variation", 0)} %
              </span>
              <div
                className={`content-variation__triangle ${
                  get(record, "variation", 0) > 0
                    ? "content-variation__triangle--positive"
                    : ""
                }`}
              />
            </>
          )}
        </div>
      </div>
    )
  }

  const columnValueIndicatorComponent = (value, record) => {
    return (
      <div>
        {record.anonymity_check.valid ? (
          <span
            style={{ backgroundColor: record.color }}
            className="table-column-result">
            {record.value_visible}
          </span>
        ) : (
          <Popover
            content={
              <div style={{ maxWidth: 220, textAlign: "center" }}>
                {intlResultTeamTableComponent.tooltipAnonymity.totalResponse}
                {record.anonymity_check.current_used}{intlResultTeamTableComponent.tooltipAnonymity.showResults}
              </div>
            }>
            <div style={{ width: "fit-content" }}>-</div>
          </Popover>
        )}
      </div>
    )
  }

  const columnActionsComponent = (value, record) => {
    return (
      <div>
        {record.anonymity_check.valid ? (
          <Link
            to={`/reports/measure/${match.params.id}/teams/${
              record.id
            }/dimensions${
              props.idSegment ? `?id_segment=${props.idSegment}` : ""
            }`}>
            {intlResultTeamTableComponent.link}
          </Link>
        ) : (
          <Popover
            content={
              <div style={{ maxWidth: 220, textAlign: "center" }}>
                {intlResultTeamTableComponent.tooltipAnonymity.totalResponse}
                {record.anonymity_check.current_used}{intlResultTeamTableComponent.tooltipAnonymity.showResults}
              </div>
            }>
            <div style={{ width: "fit-content" }}>
              {intlResultTeamTableComponent.link}
            </div>
          </Popover>
        )}
      </div>
    )
  }

  const titlePreviousMeasurementComponent = () => {
    const contentVariation = () => {
      return (
        <div className="content-variation">
          <p>{sanitize(intlResultTeamTableComponent.tooltipPreviousMeasure)}</p>
          <div>
            <div className="content-variation__triangle content-variation__triangle--positive" />
            {intlResultTeamTableComponent.positiveVariation}
          </div>
          <div>
            <div className="content-variation__triangle" />
            {intlResultTeamTableComponent.negativeVariation}
          </div>
        </div>
      )
    }
    return (
      <div>
        <span>
          {`${intlResultTeamTableComponent.previousMeasure} `}
          <Popover placement="bottomRight" content={contentVariation}>
            <img
              src={questionIcon}
              alt="question"
              style={{ marginLeft: 4, cursor: "pointer" }}
            />
          </Popover>
        </span>
      </div>
    )
  }

  const columns = () => {
    let surveyName =
      !validate.exist(measureInfo) || validate.empty(measureInfo)
        ? ""
        : measureInfo.survey_type_name

    let scopeType = validate.exist(measureInfo) ? measureInfo.id_scope_type : 1

    const existSegment =
      scopeType === 1 ||
      measureInfo.segments.length === 1 ||
      (validate.exist(props.idSegment) && !validate.empty(props.idSegment))

    let response = [
      {
        title: intlResultTeamTableComponent.leader,
        dataIndex: "full_name",
        key: "full_name",
        active: 1,
        width: 240,
        sorter: (a, b) => a.full_name.localeCompare(b.full_name),
      },
      {
        title: intlResultTeamTableComponent.responseRate,
        dataIndex: "employees",
        key: "employees",
        active: 1,
        width: 116,
      },
      {
        title: intlResultTeamTableComponent.division,
        dataIndex: "division_name",
        key: "division_name",
        active: 1,
        width: 240,
      },
      {
        title: intlResultTeamTableComponent.responseRate,
        dataIndex: "response_rate",
        key: "response_rate",
        active: 1,
        width: 220,
        render: (_, record) => <div>{columnProgressComponent(_, record)}</div>,
      },
      {
        title: surveyName,
        dataIndex: "value_visible",
        key: "value_visible",
        active: 1,
        sorter: (a, b) => a.value_visible.localeCompare(b.value_visible),
        width: 188,
        render: (_, record) => (
          <div>{columnValueIndicatorComponent(_, record)}</div>
        ),
      },
      {
        title: titlePreviousMeasurementComponent(),
        dataIndex: "variation",
        key: "variation",
        active: 1,
        width: 180,
        render: (_, record) => (
          <div>{columnPreviousMeasurementComponent(_, record)}</div>
        ),
      },
      {
        title: intlResultTeamTableComponent.actions,
        dataIndex: "id",
        key: "id",
        active: existSegment ? 1 : 0,
        width: 172,
        render: (_, record) => <div>{columnActionsComponent(_, record)}</div>,
      },
    ]

    response = response.filter((item) => item.active === 1)

    return response
  }

  return (
    <Table
      className="result-team-table"
      dataSource={dataSource}
      columns={columns()}
      bordered
      loading={isLoading}
      size="middle"
      showSorterTooltip={false}
      rowKey={(record) => record.id}
      pagination={{
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        size: "default",
        defaultPageSize: 10,
        locale: { items_per_page: "/ página" },
        defaultCurrent: 1,
      }}
    />
  )
}

ResultTeamTableComponent.propTypes = {}

export default ResultTeamTableComponent
